module.exports = __webpack_public_path__ + "static/media/stonks.712b5a71.png";